// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"210":"96f1c0b2497c400d801d","963":"98f65451952d69587a2e"}[chunkId] + ".bundle.js";
};